<template>
  <main class="card__container h-100">
    <div v-if="withLoading" class="loading-bar"></div>
    <section class="card__header">
      <span class="text--topic">{{ cardTopic }}</span>
      <div v-if="linkTo" class="pagination--button" @click="linkToPage()">
        <span class="text--more">More</span>
        <feather-icon
          icon="ArrowRightIcon"
          class="icon-arrow--style"
        ></feather-icon>
      </div>
    </section>
    <div class="content__max-height">
      <section class="card__content">
        <slot></slot>
      </section>
    </div>
  </main>
</template>

<script>
export default {
  name: "AtomCardWithLoading",
  props: {
    cardTopic: {
      type: String,
      required: false,
      default: "",
    },
    linkTo: {
      type: String,
      required: false,
      default: "",
    },
    withLoading: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  methods: {
    linkToPage() {
      this.$router.push(this.linkTo)
    },
  },
}
</script>

<style lang="scss" scoped>
.card__container {
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
}

.card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 17px 20px;
  margin-bottom: 6px;
}

.card__content {
  padding: 0 20px;
}

.content__max-height {
  max-height: calc(100vh - 17rem);
  overflow-y: auto;
}

.text--topic {
  color: #5e5873;
  font-weight: 600;
  font-size: 14px;
}

.text--more {
  color: #b9b9c3;
  font-weight: 400;
  font-size: 14px;
}

.icon-arrow--style {
  color: #b9b9c3;
  margin-left: 3px;
  margin-bottom: 3px;
}

.pagination--button {
  &:hover {
    cursor: pointer;
  }
}
</style>
